import { render, staticRenderFns } from "./GestionCliente.vue?vue&type=template&id=4ec2bd34&"
import script from "./GestionCliente.vue?vue&type=script&lang=js&"
export * from "./GestionCliente.vue?vue&type=script&lang=js&"
import style0 from "./GestionCliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports